export const links = {
    LINKEDIN: 'https://www.linkedin.com/in/oben-tabiayuk',
    RESUME: 'https://drive.google.com/file/d/1JnrtG7HPJCz47Hkp8WuOrb_KEhDV-eOL/view?usp=sharing',
    PORTFOLIO: 'https://projects-portfolio-p0qe.onrender.com/'
};